function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.14,
    height: 10.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.29125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 5.165
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.33,
    width: 26.14,
    height: 22.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.77375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 21.425
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.52,
    width: 26.14,
    height: 27.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.228
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 46.175000000000004
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.83,
    width: 26.14,
    height: 29.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.228
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 74.75999999999999
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.69,
    width: 26.14,
    height: 38.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9044444444444446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 108.835
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 127.98,
    width: 26.14,
    height: 40.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 148.24
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168.5,
    width: 26.14,
    height: 44.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7342857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 190.66
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.82,
    width: 26.14,
    height: 45.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7342857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 235.49
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 258.16,
    width: 26.14,
    height: 49.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 283.01000000000005
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 307.86,
    width: 26.14,
    height: 50.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 333.19
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.52,
    width: 26.14,
    height: 51.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.228
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 384.195
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.87,
    width: 26.14,
    height: 55.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 437.65
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.43,
    width: 26.14,
    height: 56.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 493.645
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.86,
    width: 26.14,
    height: 57.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 550.535
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.21,
    width: 26.14,
    height: 58.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 608.69
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.17,
    width: 26.14,
    height: 61.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.07,
    y: 669.0849999999999
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 0,
    width: 35.33,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.805,
    y: 23.09
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.47,
    y: 0,
    width: 35.91,
    height: 46.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5909999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.425,
    y: 23.09
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.38,
    y: 0,
    width: 38.5,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.63,
    y: 23.09
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.89,
    y: 0,
    width: 40.17,
    height: 46.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.738571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.975,
    y: 23.09
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.06,
    y: 0,
    width: 40.76,
    height: 46.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.793333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.44,
    y: 23.09
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.82,
    y: 0,
    width: 41.08,
    height: 46.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.35999999999999,
    y: 23.09
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.89,
    y: 0,
    width: 44.07,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.925,
    y: 23.09
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.96,
    y: 0,
    width: 44.48,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.354285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.2,
    y: 23.09
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.44,
    y: 0,
    width: 44.51,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.56375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.695,
    y: 23.09
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.94,
    y: 0,
    width: 45.86,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.87,
    y: 23.09
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.81,
    y: 0,
    width: 48.46,
    height: 46.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.04,
    y: 23.09
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.27,
    y: 0,
    width: 49,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.597142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.77,
    y: 23.09
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.27,
    y: 0,
    width: 53.76,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.198181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.15,
    y: 23.09
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.03,
    y: 0,
    width: 54.64,
    height: 46.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.696666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.35,
    y: 23.09
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.67,
    y: 0,
    width: 57.33,
    height: 46.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.131111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.3349999999999,
    y: 23.09
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 46.18,
    width: 59.74,
    height: 46.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 69.35
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 92.52,
    width: 59.74,
    height: 46.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 115.78999999999999
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 139.07,
    width: 59.74,
    height: 48.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.143333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 163.5
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 187.93,
    width: 59.74,
    height: 49.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0042857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 212.445
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 236.96,
    width: 59.74,
    height: 49.33,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 261.625
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 286.29,
    width: 59.74,
    height: 50.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.175833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 311.345
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 336.4,
    width: 59.74,
    height: 53.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5928571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 362.97499999999997
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 389.56,
    width: 59.74,
    height: 60.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 419.71500000000003
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 449.86,
    width: 59.74,
    height: 74.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.974
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 487.035
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 524.22,
    width: 59.74,
    height: 87.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.430909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 567.955
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.14,
    y: 611.69,
    width: 59.74,
    height: 88.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.974
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.010000000000005,
    y: 655.845
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 46.18,
    width: 69.66,
    height: 82.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.71,
    y: 87.22
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 46.18,
    width: 77.4,
    height: 82.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.24,
    y: 87.22
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.94,
    y: 46.18,
    width: 83.24,
    height: 82.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.725714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.56,
    y: 87.22
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.18,
    y: 46.18,
    width: 86.05,
    height: 82.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.205,
    y: 87.22
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.23,
    y: 46.18,
    width: 93.37,
    height: 82.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.915,
    y: 87.22
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.61,
    y: 46.18,
    width: 99.39,
    height: 82.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.3050000000001,
    y: 87.22
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 46.18,
    width: 105,
    height: 82.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.5,
    y: 87.22
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 128.26,
    width: 117.05,
    height: 74.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.341666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.405,
    y: 165.285
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 202.31,
    width: 117.05,
    height: 89.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.405,
    y: 246.96
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 291.61,
    width: 117.05,
    height: 93.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.405,
    y: 338.56
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 385.51,
    width: 117.05,
    height: 129.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.63125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.405,
    y: 450.45
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.88,
    y: 515.39,
    width: 117.05,
    height: 184.61,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.405,
    y: 607.6949999999999
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 128.26,
    width: 144.52,
    height: 166.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.08666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.19,
    y: 211.565
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.45,
    y: 128.26,
    width: 160.85,
    height: 166.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.622727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.875,
    y: 211.565
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 128.26,
    width: 191.7,
    height: 166.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 41.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.15,
    y: 211.565
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 294.88,
    width: 189.94,
    height: 198.06,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.9,
    y: 393.90999999999997
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 492.93,
    width: 189.94,
    height: 207.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.656666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.9,
    y: 596.465
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.87,
    y: 294.88,
    width: 151.74,
    height: 264.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.677142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.74,
    y: 427.27
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.61,
    y: 294.88,
    width: 155.39,
    height: 264.78,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.077999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.3050000000001,
    y: 427.27
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.87,
    y: 559.65,
    width: 307.13,
    height: 140.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.391666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.435,
    y: 629.8249999999999
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.70611db2b74761d6a43369ad513cb2dd.svg";
export { ForwardRef as ReactComponent };